import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17db7ba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lms-module-overview" }
const _hoisted_2 = {
  key: 0,
  class: "loading-screen"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "module-hero" }
const _hoisted_6 = { class: "hero-text" }
const _hoisted_7 = { class: "hero-eyebrow" }
const _hoisted_8 = { class: "hero-title" }
const _hoisted_9 = {
  key: 0,
  class: "hero-desc"
}
const _hoisted_10 = { class: "hero-meta" }
const _hoisted_11 = { class: "hero-meta-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hero-meta-item" }, "✏️ Online-Fortbildung", -1))
const _hoisted_13 = {
  key: 0,
  class: "hero-meta-item"
}
const _hoisted_14 = {
  key: 1,
  class: "hero-progress"
}
const _hoisted_15 = { class: "progress-bar-wrap" }
const _hoisted_16 = { class: "hero-progress-label" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hero-cta-arrow" }, "→", -1))
const _hoisted_18 = { class: "hero-media" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 1,
  class: "hero-img hero-img--placeholder"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hero-badge" }, "✓ Zertifizierte Fortbildung", -1))
const _hoisted_22 = { class: "lessons-container" }
const _hoisted_23 = {
  key: 0,
  class: "no-lessons"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dieser Kurs hat noch keine Lektionen.", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "lessons-heading" }, "Lektionen", -1))
const _hoisted_26 = { class: "lesson-list" }
const _hoisted_27 = { class: "lesson-number" }
const _hoisted_28 = {
  key: 0,
  class: "done-check"
}
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "lesson-info" }
const _hoisted_31 = { class: "lesson-title" }
const _hoisted_32 = {
  key: 0,
  class: "lesson-desc"
}
const _hoisted_33 = {
  key: 1,
  class: "lesson-date"
}
const _hoisted_34 = { class: "lesson-status" }
const _hoisted_35 = {
  key: 0,
  class: "lesson-progress-wrap"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  class: "loading-screen"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#60666c"} }, "Kurs nicht gefunden.", -1))
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.module)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              class: "back-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'lmsCatalog' })))
            }, " ← Zurück zur Übersicht "),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.eyebrow), 1),
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.module.title), 1),
                (_ctx.module.description)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.module.description), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, "⏱ " + _toDisplayString(_ctx.spentLabel), 1),
                  _hoisted_12,
                  (_ctx.lessons.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.completedCount) + "/" + _toDisplayString(_ctx.lessons.length) + " Lektionen ", 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.lessons.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["progress-bar-fill", { complete: _ctx.completedCount === _ctx.lessons.length }]),
                          style: _normalizeStyle({ width: _ctx.overallPercent + '%' })
                        }, null, 6)
                      ]),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.overallPercent) + " %", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "hero-cta",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startPrimary && _ctx.startPrimary(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.ctaLabel) + " ", 1),
                  _hoisted_17
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.module.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.module.image,
                      alt: _ctx.module.title,
                      class: "hero-img"
                    }, null, 8, _hoisted_19))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20)),
                _hoisted_21
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_ctx.lessons.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    (_ctx.module.lms_path)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn-start-course",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startCourseDirect && _ctx.startCourseDirect(...args)))
                        }, " Kurs starten "))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lessons, (lesson, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: lesson.lessonId,
                          class: _normalizeClass(["lesson-card", {
              'is-done': _ctx.isLessonDone(lesson.lessonId),
              'is-progress': _ctx.isLessonInProgress(lesson.lessonId),
              'is-locked': false
            }])
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            (_ctx.isLessonDone(lesson.lessonId))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "✓"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(idx + 1), 1))
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("h3", _hoisted_31, _toDisplayString(lesson.title), 1),
                            (lesson.description)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(lesson.description), 1))
                              : _createCommentVNode("", true),
                            (_ctx.isLessonDone(lesson.lessonId))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, " Abgeschlossen " + _toDisplayString(_ctx.formatDate(_ctx.lessonCompletedAt(lesson.lessonId))), 1))
                              : (_ctx.isLessonInProgress(lesson.lessonId))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("span", _hoisted_34, "In Bearbeitung" + _toDisplayString(_ctx.lessonPercentLabel(lesson.lessonId)), 1),
                                    (_ctx.hasLessonMeasure(lesson.lessonId))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                          _createElementVNode("div", {
                                            class: "lesson-progress-fill",
                                            style: _normalizeStyle({ width: _ctx.lessonPercent(lesson.lessonId) + '%' })
                                          }, null, 4)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("button", {
                            class: _normalizeClass(["lesson-btn", {
                'btn-done': _ctx.isLessonDone(lesson.lessonId),
                'btn-resume': _ctx.isLessonInProgress(lesson.lessonId),
              }]),
                            onClick: ($event: any) => (_ctx.openLesson(lesson.lessonId))
                          }, _toDisplayString(_ctx.lessonButtonLabel(lesson)), 11, _hoisted_36)
                        ], 2))
                      }), 128))
                    ])
                  ], 64))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
  ]))
}